import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Store } from '@ngxs/store';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { AssetService } from '~/core/services/assets/asset.service';
import { AppState } from '~/core/store';
import { RegionSettings } from '~/core/store/regionalSettings/regionalSettings.model';
import { MetaTagService } from '~/core/utils/global-utils/global-utils';
import { HtmlRoutePages } from '../../app-routing.model';
import { MetaPageEnum, NavLinks, regionEnum } from '../../core/declaration/declaration';
import { SidenavService } from '../../core/services/sidenav/sidenav.service';
import { RegionalSettingsService } from '../../core/store/regionalSettings/regionalSettings.service';
import { GlobalUtils } from '../../core/utils/global-utils/global-utils';
import { ScreenUtils } from '../../core/utils/screen-utils/screen-utils';
@Component({
    selector: 'volvo-service-page',
    templateUrl: './service-page.component.html',
    styleUrls: ['./service-page.component.scss'],
})
export class ServicePageComponent implements OnInit {
    HtmlRoutePages: HtmlRoutePages
    navlinks: NavLinks[];
    isTablet: boolean = false
    region: string;
    regionEnum = regionEnum;
    path: string = '';
    regionalSettings: RegionSettings;
    site: string;
    isSelectedSite: boolean = false;
    constructor(private sidenavService: SidenavService, private ngDynamicBreadcrumbService: NgDynamicBreadcrumbService, public assetService: AssetService,
        public store: Store,
        private metaTagService: MetaTagService, private regionalSettingsService: RegionalSettingsService,
        private localizeRouterService: LocalizeRouterService, private globalUtils: GlobalUtils, private router: Router, private route: ActivatedRoute) {
        this.navlinks = sidenavService.getNavLinks();
        this.region = store.selectSnapshot<string>((state: AppState) => state.language.region.curRegion.id);
        this.regionalSettings = store.selectSnapshot<RegionSettings>((state: AppState) => state.regionalSettings.regionsSettings.filter(r => r.region === this.region)[0]);
        if (this.regionalSettings && this.regionalSettings.site === "volvoselected") this.isSelectedSite = true;
    }
    ngOnInit() {
        if (this.globalUtils.isBrowser() && ScreenUtils.isTablet()) {
            this.isTablet = true;
        }
        this.updateBreadcrumb();
        this.metaTagService.updateTagFor(MetaPageEnum.Services);
    }
    updateBreadcrumb(): void {
        const breadcrumbsConts = [
            {
                label: 'Services',
                url: ""
            },
            {
                label: '',
                url: ""
            }
        ];
        //this.ngDynamicBreadcrumbService.updateBreadcrumb(breadcrumbsConts);
    }
    routePage(link): void {
        this.router.navigate([this.localizeRouterService.translateRoute(link)], {
            relativeTo: this.route
        });
    }
    ngAfterViewInit(): void {
        this.scrollToElement();
    }
    scrollToElement(): void {
        if (this.path) {
            const el = document.getElementById(this.path);
            if (el) {
                el.scrollIntoView({ behavior: 'auto', inline: 'start' });
            }
            // Meta tag update logic for subpages can be handled here if needed
        }
    }
}
